import React, { FC, useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import { useStore } from "stores/utils/use-store"
import { observer } from "mobx-react"
import { Select, Table } from "antd"
import { accountGamesColumnsBuffPlay } from "./columns"
import Search from "antd/es/input/Search"
import InfiniteScroll from "components/InfiniteScroll"
import Styles from "./styles.module.css"
import { EditIconButton } from "components"
import {
  SOURCE_GAME_OPTIONS,
  SourceGameType,
} from "../constants/source-options"
import { AccountNativeGameBuffPlay } from "./account-native-game-BuffPlay"


export const AccountGamesBuffPlay: FC = observer<FC>(() => {
  const { id } = useParams<{ id: string }>()
  const { dataStore: { accountGamesBuffPlayStore } } = useStore()
  const [selectedGame, setSelectedGame] = useState<any | null>(null)

  const searchNameHandler = async(value: string) => {
    accountGamesBuffPlayStore.gameName = value
  }

  useEffect(() => {
    accountGamesBuffPlayStore.loadedPages = 1
    accountGamesBuffPlayStore.setFilter({
      ...accountGamesBuffPlayStore.filter,
      name: accountGamesBuffPlayStore.gameName,
      source: accountGamesBuffPlayStore.gameSource,
    })
  }, [accountGamesBuffPlayStore.gameName, accountGamesBuffPlayStore.gameSource])

  useEffect(() => {
    if (!id) {
      return
    }

    accountGamesBuffPlayStore.getGamesBuffPlay(id)
  }, [accountGamesBuffPlayStore, id])

  const columns = [
    ...accountGamesColumnsBuffPlay,
    {
      title: "Pending Tasks",
      dataIndex: "pendingTasks",
      key: "pendingTasks",
      render: (_, data) => {
        const pendingTasksCount = (data.tasks ?? []).filter(
          task => task.status === "PENDING",
        ).length

        return (
          <div className={Styles.tasks}>
            {`${pendingTasksCount}/${(data.tasks ?? []).length}`}
          </div>
        )
      },
    },
    {
      title: "Update Game",
      dataIndex: "update",
      key: "update",
      render: (_, data) => (
        <div className={Styles.actions}>
          <EditIconButton
            onClick={() => {
              setSelectedGame(data)
            }}
          />
        </div>
      ),
    },
  ]

  return (
    <>
      <div style={{ display: "flex", alignItems: "center", height: "40px", gap: 10 }}>
        Filters:
        <Search
          style={{ width: "500px" }}
          placeholder="Name"
          enterButton
          onSearch={searchNameHandler}
        />
        <div>Source: </div>
        <Select
          style={{ width: "140px" }}
          defaultValue={accountGamesBuffPlayStore.gameSource}
          value={accountGamesBuffPlayStore.gameSource}
          onChange={(value: SourceGameType) => accountGamesBuffPlayStore.gameSource = value}
        >
          {SOURCE_GAME_OPTIONS.map(option => (
            <Select.Option value={option} key={option}>
              {option}
            </Select.Option>
          ))}
        </Select>
      </div>
      <Table
        dataSource={accountGamesBuffPlayStore.accountGames || []}
        columns={columns}
        rowKey="id"
        pagination={false}
        loading={accountGamesBuffPlayStore.isLoading}
        onChange={(p, c, sorter: any) => {
          accountGamesBuffPlayStore.setFilter({
            ...accountGamesBuffPlayStore.filter,
            createdAtOrder: sorter.order === "ascend" ? "ASC" : "DESC",
            lastDate: undefined,
          })
          accountGamesBuffPlayStore.loadedPages = 1
        }}
      />
      <InfiniteScroll
        onLoadMore={() => {
          accountGamesBuffPlayStore.loadedPages += 1
          id && accountGamesBuffPlayStore.getData()
        }}
        isLoading={accountGamesBuffPlayStore.isLoading}
        hasMore={
          accountGamesBuffPlayStore.accountGames?.length < accountGamesBuffPlayStore.total
        }
      />
      {selectedGame && (
        <AccountNativeGameBuffPlay selectedGame={selectedGame} setSelectedGame={setSelectedGame} />
      )}
    </>
  )
})
